import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import ResiliaIconBlue from 'Components/Views/AppBar/AppLogoBlue'
import { colors } from '@resiliatech/birdsong'
import { CohortLearningSection } from './CohortLearningSection'
import { ExecutiveSummarySection } from './ExecutiveSummarySection'
import { GoalsSection } from './GoalsSection'

export const ReportSection = ({ data }: any) => (
  <Container>
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <ResiliaIconBlue />
      <b>
        {data?.funderName} • {data?.monthString}
      </b>
    </Box>

    <Section>
      <Typography variant='h6'>Your Monthly digest is here</Typography>
      <Typography variant='body1'>
        We’ve captured all activity from your cohort to create this report
        comparing to previous month.
      </Typography>
      <Typography variant='body1'>
        Aligned to Trust Based Philanthropy principles we don’t display specific
        data or anything that hasn’t been agreed to be shared.
      </Typography>
      <div style={{ width: '100%', height: '1px', backgroundColor: 'gray' }} />
      <Typography variant='h6'>Cohort Highlights</Typography>
      <Typography variant='body1'>
        {data?.executiveSummary ? (
          ExecutiveSummarySection({ executiveSummary: data.executiveSummary })
        ) : (
          <i>PLACEHOLDER - EXECUTIVE SUMMARY GOES HERE</i>
        )}
      </Typography>
    </Section>

    {/* no needs assesment data needed for now 
    <Section>
      <Typography variant='h6'>Your Cohort&apos;s Priority Areas</Typography>

      <Typography variant='body1'>
        {data?.cohortPriority || <i>PLACEHOLDER - COHORT PRIORITY GO HERE</i>}
      </Typography>
    </Section> */}

    <Section>
      <Typography variant='h6'>What are your nonprofits saying?</Typography>

      <Typography variant='body1'>
        {(data?.testimonial && (
          <div style={{ fontStyle: 'italic' }}>
            &quot;{getSplits(data?.testimonial)}&quot;
          </div>
        )) || <i>TESTIMONIAL GO HERE</i>}
      </Typography>
    </Section>

    <Section>
      <Typography variant='h6'>What are they learning</Typography>

      <Typography variant='body1'>
        {data?.cohortLearnings ? (
          CohortLearningSection({ cohortLearnings: data.cohortLearnings })
        ) : (
          <i>PLACEHOLDER - COHORT LEARNINGS GO HERE</i>
        )}
      </Typography>
    </Section>

    <Section>
      <Typography variant='h6'>Cohort Goal Progress</Typography>

      <Typography variant='body1'>
        {data?.cohortGoalProgress ? (
          GoalsSection({ goals: data.cohortGoalProgress })
        ) : (
          <i>PLACEHOLDER - COHORT GOAL PROGRESS GO HERE</i>
        )}
        {data?.goalsSharedWithFunder[0] && (
          <>
            <p
              style={{ fontWeight: 600, fontSize: '16px', textAlign: 'center' }}
            >
              Latest updates on some Goals shared with you
            </p>
            {data?.goalsSharedWithFunder.map(
              (goal: {
                goalName: string
                nonprofitName: string
                fractionCompleteString: string
              }) => (
                <div key={goal.goalName}>
                  <p style={{ fontSize: '14px', fontWeight: 600 }}>
                    {goal.goalName}
                  </p>
                  <p style={{ fontSize: '12px' }}>
                    Owned By{' '}
                    <span style={{ fontWeight: 600 }}>
                      {goal.nonprofitName}
                    </span>
                  </p>
                  <p style={{ fontSize: '12px' }}>
                    Last update{' '}
                    <span style={{ fontWeight: 600 }}>
                      {goal.fractionCompleteString}
                    </span>
                  </p>
                </div>
              )
            )}
          </>
        )}

        {data?.storiesSharedWithFunder[0] && (
          <>
            <p
              style={{ fontWeight: 600, fontSize: '16px', textAlign: 'center' }}
            >
              Recent stories shared with you
            </p>

            {data?.storiesSharedWithFunder.map(
              (story: {
                storyName: string
                funderStoryUrl: string
                nonprofitName: string
              }) => (
                <div key={story.storyName}>
                  <a href={story.funderStoryUrl}>
                    <p
                      style={{
                        fontWeight: 600,
                        fontSize: '14px',
                        color: '#003F7E',
                      }}
                    >
                      {story.storyName}
                    </p>
                  </a>
                  <p style={{ fontSize: '12px' }}>
                    Owned by{' '}
                    <span style={{ fontWeight: 600 }}>
                      {story.nonprofitName}
                    </span>
                  </p>
                </div>
              )
            )}
          </>
        )}
      </Typography>
    </Section>

    <Footer style={{ textAlign: 'center' }}>
      <Typography variant='body1'>Footer Stuff</Typography>
    </Footer>
    <Box>
      <Typography variant='body1'>
        This email was created with the power of AI, the information reflects
        your nonprofits’s efforts captured in the Resilia platform by the end of
        this month compared to the previous month, it doesn’t reflect any
        progress they may have made outside Resilia.
      </Typography>
    </Box>
    <div style={{ textAlign: 'center' }}>
      Powered by <ResiliaIconBlue />
    </div>
  </Container>
)

const getSplits = (text: string) =>
  text.split('\n').map((line, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <span key={index}>
      {line}
      {text.split('\n').length !== index + 1 && <br />}
    </span>
  ))

const Container = styled(Box)`
  background: #faf8f5;
  max-width: 600px;
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  padding: 36px 24px 36px 24px;
  gap: 24px;
  border: 2px solid #e0e0e0;
  margin-bottom: 36px;
  margin: 0 auto;
`

const Section = styled(Box)`
  background: white;
  padding: 16px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`

const Footer = styled(Section)`
  color: ${colors.copy.paragraphLight};
  background: ${colors.interactive.primaryEnabled};
  height: 100px;
`
